import { get, patch, collectPagedResource } from '../httpHelpers/primer';
import { SeriesComponentsDates, SeriesData, SeriesDetails } from '../../types/Series';
import { BusinessUnit, Series } from '@cambridgeassessment/lib-ee-commons';

export const getSeriesResponse = async (businessUnitId: string, year?: number): Promise<SeriesData> =>
  await collectPagedResource(`v1/businessUnit/${businessUnitId}/series${year ? `?year=${year}` : ''}`);

export const getSeriesDetails = async (businessUnitId: string, seriesId: Series['id']): Promise<SeriesDetails> =>
  await get(`v1/businessUnit/${businessUnitId}/series/${seriesId}`);

export const updateBufferDate = async (
  seriesId: Series['_id'],
  buffer: string,
  submissionWindowName: string,
  field: string,
): Promise<SeriesDetails> =>
  patch(`v1/id/series/${seriesId}/submissionWindows?name=${submissionWindowName}&field=${field}`, {
    value: buffer,
  });

export const getActiveSeries = async (
  businessUnitId: string,
): Promise<{ active?: Series[]; previous?: Series[]; future?: Series[] }> =>
  await get(`v1/businessUnit/${businessUnitId}/series/active`);

export const updateDateByFieldName = (seriesId: Series['_id'], date: string, field: string): Promise<SeriesDetails> =>
  patch(`v1/id/series/${seriesId}?field=${field}`, {
    value: date,
  });

export const getSeriesComponents = async (
  businessUnitId: BusinessUnit['id'],
  seriesId: Series['id'],
): Promise<SeriesComponentsDates> => get(`v1/businessUnit/${businessUnitId}/series/${seriesId}/component-dates`);
